import logo from "../images/logo.png"
import business from "../images/business.png"
import team from "../images/team.png"
import map from "../images/map.png"
import a1 from "../images/a1.jpeg"
import a2 from "../images/a2.jpeg"
import a3 from "../images/a3.jpeg"
import i4 from "../gallery/4.jpeg"


function About() {
  return (
    <div class="container">
      <section class="py-5 text-center container">
        <div class="row py-lg-5"
          style={{
            backgroundImage: `url(${a1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            height: "300px", objectFit: "cover"
          }}>
        </div>
      </section>
      <h1>Know More About Us</h1>
      <hr class="featurette-divider" />
      <div class="row featurette">
        <div class="col-md-7">
          <h2 class="featurette-heading">We take pride in our quality, service and commitment.</h2>
          <span class="text-muted"><h4>
            <br />&raquo; Premium Quality Products with Superior Finishes<br />
            <br />&raquo; Customized Solutions Tailored to Every Space<br />
            <br />&raquo; Skilled Workforce with Professional Installation<br />
            <br />&raquo; Timely Project Execution with Transparent Pricing<br />
            <br />&raquo; After-Sales Support & Customer Satisfaction Guarantee</h4></span>
        </div>
        <div class="col-md-5">
          <img src={i4} className="bd-placeholder-img bd-placeholder-img-lg featurette-image img-fluid mx-auto" alt="Thumbnail" style={{ height: "500px", width: "500px" }} />
        </div>
      </div>

      <hr class="featurette-divider" />

      <div class="row featurette">
        <div class="col-md-7 order-md-2">
          <h2 class="featurette-heading">SkyIndoor have provide high quality doors and windows to Indian Consumers. The company has exclusive contract for manufacturing and assembling.</h2>
          <span class="text-muted"><h4>
            <br />&raquo; Lightweight & Strong: High strength-to-weight ratio.<br />
            <br />&raquo; Corrosion Resistant: Naturally resists rust.<br />
            <br />&raquo; Versatile: Easily shaped and formed.<br />
            <br />&raquo; Conductive: Good thermal and electrical properties.<br />
            <br />&raquo; Sustainable: Highly recyclable.</h4></span>
        </div>
        <div class="col-md-5 order-md-1">
          <img src={a2} className="bd-placeholder-img bd-placeholder-img-lg featurette-image img-fluid mx-auto" alt="Thumbnail" style={{ height: "500px", width: "500px" }} />

        </div>
      </div>

      <hr class="featurette-divider" />

      <div class="row featurette">
        <div class="col-md-7">
          <h2 class="featurette-heading">Our Story</h2>
          <span class="text-muted"><h3><br />
            &raquo; At Skyindoors, our journey reflects our passion for transforming spaces with innovative window, door, and glass solutions.<br />
            &raquo; From humble beginnings to becoming Hyderabad’s trusted name in the industry, every milestone we achieved is built on dedication, hard work, and customer trust.
          </h3></span>
        </div>
        <div class="col-md-5">
          <img src={a3} className="bd-placeholder-img bd-placeholder-img-lg featurette-image img-fluid mx-auto" alt="Thumbnail" style={{ height: "500px", width: "500px" }} />
        </div>
      </div>


      <hr class="featurette-divider" />

      <div class="row">
        <div class="col-lg-4">
          <img src={logo} className="bd-placeholder-img rounded-circle" alt="Thumbnail" style={{ height: "140px", width: "140px" }} />

          <h2>Our Product</h2>
          <p>We use only premium materials and the highest quality workmanship to give you the best product possible.</p>
        </div>
        <div class="col-lg-4">
          <img src={business} className="bd-placeholder-img rounded-circle" alt="Thumbnail" style={{ height: "140px", width: "140px" }} />

          <h2>11+ Years in business</h2>
          <p> It is backed by our 10-year warranty, so you can be confident that your windows and doors will serve you for years to come.</p>
        </div>
        <div class="col-lg-4">
          <img src={team} className="bd-placeholder-img rounded-circle" alt="Thumbnail" style={{ height: "140px", width: "140px" }} />

          <h2>Our Team</h2>
          <p>Trained Installation team with proper tools for great performance, sustainability, sound insulation and security.</p>
        </div>
      </div>
      <hr class="featurette-divider" />
      <div class="row">
        <div class="col-sm-6"
          style={{
            backgroundImage: `url(${map})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}>
          <div class="card">
          </div>
        </div>
        <div class="col-sm-6">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">SKYINDOORS Aluminium Fabrication</h5>
              <p class="card-text">You tell us your vision. We will provide the solution.</p>
              <p class="card-text">12-2-389/A/117/B Mahaveer nager, GuddiMalkapur, Hyderabad, TG - 500028</p>
              <a href="https://maps.app.goo.gl/BbUrWLEoKcd7WHyp6?g_st=aw" class="btn btn-success">Go somewhere</a>
            </div>
          </div>
        </div>
      </div>
      <hr class="featurette-divider" />

    </div>
  );
}

export default About;
